<template>
    <Page>
        <Container class="max-w-screen-sm">
            <div class="flex items-center justify-between mb-6">
                <Title class="!mb-0">Request Debug</Title>
                <Button size="sm" secondary outlined @click="loadData">
                    Refresh
                </Button>
            </div>

            <Loading v-if="loading" />

            <div class="space-y-8" v-if="data && !loading">
                <section v-for="section in sections" :key="section.key">
                    <Subtitle>{{ section.title }}</Subtitle>
                    <div v-if="!section.rows.length" class="text-sm text-neutral-500 dark:text-neutral-400">
                        {{ section.empty }}
                    </div>
                    <table v-else class="w-full text-sm">
                        <tbody>
                            <tr v-for="row in section.rows"
                                :key="row.key"
                                class="border-b border-neutral-100 dark:border-neutral-800 last:border-b-0">
                                <td class="py-2 pr-3 align-top font-semibold text-neutral-600 dark:text-neutral-300">
                                    {{ row.label }}
                                </td>
                                <td class="py-2 text-right align-top break-all text-neutral-900 dark:text-neutral-100">
                                    {{ row.value }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>

            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'
import {mapActions} from 'vuex';

export default defineComponent({
  name: 'RequestDebug',
  created() {
    this.loadData();
  },
  data() {
    return {
      data: null,
      loading: false,
    };
  },
  computed: {
    sections() {
      return [
        {
          empty: 'No routing cookies detected',
          key: 'routingCookies',
          rows: this.rowsFor(this.data?.routing_cookies),
          title: 'Routing Cookies',
        },
        {
          empty: 'No data',
          key: 'request',
          rows: this.rowsFor(this.data?.request),
          title: 'Request',
        },
        {
          empty: 'No data',
          key: 'client',
          rows: this.rowsFor(this.data?.client),
          title: 'Client',
        },
        {
          empty: 'No data',
          key: 'proxy',
          rows: this.rowsFor(this.data?.proxy),
          title: 'Proxy',
        },
        {
          empty: 'No data',
          key: 'server',
          rows: this.rowsFor(this.data?.server),
          title: 'Server',
        },
        {
          empty: 'No cookies found',
          key: 'cookies',
          rows: this.rowsFor(this.data?.cookies),
          title: 'Cookies',
        },
        {
          empty: 'No data',
          key: 'headers',
          rows: this.rowsFor(this.data?.headers),
          title: 'Headers',
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      adminRequestDebug: 'admin/requestDebug',
    }),
    loadData() {
      this.loading = true;

      return this.adminRequestDebug().then((response) => {
        this.data = response.data.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    rowsFor(value) {
      if (!value || typeof value !== 'object') {
        return [];
      }

      return Object.entries(value).map(([key, rowValue]) => {
        return {
          key,
          label: this.formatLabel(key),
          value: this.formatValue(rowValue),
        };
      });
    },
    formatLabel(value) {
      return value
        .replace(/_/g, ' ')
        .replace(/\b\w/g, character => character.toUpperCase());
    },
    formatValue(value) {
      if (Array.isArray(value)) {
        return value.length ? value.join(', ') : '-';
      }

      if (value === null || value === undefined || value === '') {
        return '-';
      }

      if (typeof value === 'object') {
        return JSON.stringify(value);
      }

      return String(value);
    },
  },
})
</script>
